import { render, staticRenderFns } from "./SupportRequestClarence.vue?vue&type=template&id=9f1cbc2e&"
import script from "./SupportRequestClarence.vue?vue&type=script&lang=js&"
export * from "./SupportRequestClarence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports